export enum PaymentMethod {
  stripe = "STRIPE",
  paypal = "PAYPAL",
  spei = "SPEI"
}